//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {email, minLength, required, not, requiredIf, or,} from "vuelidate/lib/validators";

export default {
  name: 'ProductNotAvailable',
  data() {
    return {
      isFormLoading: false,
      isOpenFormCallBack: false,

      form: {
        type: 'Запрос на уведомление о появлении товара',
        email: '',
        phone: '',
        title: '',
      },
    }
  },
  validations: {
    // Настройка валидации контактной информации
    form: {
      email: {
        required: requiredIf(function (value, vm) {
          return !value.phone.length;
        }),
        email
      },

      phone: {
        required: requiredIf(function (value, vm) {
          return !value.email.length;
        }),
        minLength: minLength(18),
      }

    }
  },

  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    activeSameProducts: {
      type: Boolean,
      default: false
    },
    showButtonPopUpForm: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    getLinkOnPage() {
      if (process.client) {
        return `https://${window.location.host}${this.$route.fullPath}`
      }
    },
  },

  components: {
    CallBackModal: () => import("~/components/modals/CallBackModal")
  },

  methods: {
    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return null;
      }
      this.isFormLoading = true

      const newForm = {...this.form}
      newForm.message = `Посетитель сайта просит уведомить о появлении товара "${this.product.name}" (${this.getLinkOnPage})`;
      newForm.url = this.getLinkOnPage;
      newForm.title = `Уведомить о наличии товара: ${this.product.name}`;

      if (!newForm.phone.length) {
        delete newForm.phone;
        newForm.nophone = 1;
      }

      const resp = await this.$api.agent.transport.post(`form/send`, newForm)
        .catch(err => {
          return {
            error: err?.response?.data?.[0]?.message || 'Ошибка сервера'
          }
        })
      if (resp.error) {
        this.$toast.error(resp.error)
        this.isFormLoading = false
        return
      }

      this.$toast.success('Ваша завяка принята')
      this.form.email = '';
      if (this.form.phone) {
        this.form.phone = '';
      }
      this.isFormLoading = false
      this.$v.$reset()
    },

    scrollToSameProducts: function () {
      const element = document.getElementById('section-other-products');
      const topScroll = window.pageYOffset;
      if (!element) {
        return
      }

      const params = element.getBoundingClientRect();
      if (!params?.top) {
        return;
      }
      window.scrollTo({
        top: (params?.top + topScroll - 120),
        behavior: "smooth"
      });
    },



    openFormCallBack: function () {
      this.isOpenFormCallBack = true;
    },
    closeFormCallBack: function () {
      this.isOpenFormCallBack = false;
    },
  },
}
